<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-03-22 08:55:59
 * @LastEditors: may.li
 * @LastEditTime: 2023-06-12 11:31:54
-->
<template>
<div class="page_qrcode">
    <div class="default">
        <img :src="imageUrl+qrcodeUrl" alt="" class="hechengqrcode" v-if="hasUrl">
        <div class="" v-else>无</div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "map-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            token: null,
			qrcodeUrl: null, // 合成二维码
			hasUrl: true,
			imageUrl: this.$publicData.uploadImage
        };
    },

    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                data: {
                    naviTitle: "分销商二维码"
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, data => {});
            //加载用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    methods: {
        // 获取列表
        getData() {
            var param = {
                token: this.token
            }
            this.$api.my.agentQRCode(param).then(res => {
                if (res.code == 200) {
					if(res.result.hbqrcode){
						this.qrcodeUrl = res.result.hbqrcode;
					}else{
						this.hasUrl = false;
					}
                } else {
					this.hasUrl = false;
                    this.$toast(res.message)
                }
            })
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
